var map = {
	"./1.png": "b1da",
	"./2.png": "d1d8",
	"./3.png": "71a3",
	"./agq.png": "88e4",
	"./bg.png": "d553",
	"./none.png": "2417",
	"./up.png": "f7ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "184d";